<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.workspace.name')}`"
    width="50%"
  >
    <div v-if="dialog.type == 'update'">
      <base-form ref="form" lazy-validation @submit.stop="onSubmit">
        <v-row no-gutters>
          <v-col cols="12">
            <field-group
              v-model="dialog.data.name"
              autofocus
              :error-messages="dialog.error.name"
              filled
              label="Tên hiển thị"
              no-label
            ></field-group>
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="dialog.data.published"
              inset
              label="Công bố"
              class="mx-1"
            >
            </v-switch>
          </v-col>
          <v-col cols="12" v-if="current_user_role == 1">
            <v-switch
              v-model="useWMS"
              inset
              label="Tuỳ chỉnh cài đặt WMS"
              class="mx-1"
              @click="getTabs()"
            >
            </v-switch>
            <v-switch
              v-model="useWFS"
              inset
              label="Tuỳ chỉnh cài đặt WFS"
              class="mx-1"
              @click="getTabs()"
            >
            </v-switch>
          </v-col>
        </v-row>
      </base-form>
      <v-tabs v-model="tab" grow v-if="current_user_role == 1">
        <v-tab v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-tab>
        <!-- Tab phân quyền -->
        <v-tab-item>
          <base-form ref="form" lazy-validation @submit.stop="onSubmit">
            <v-row no-gutters>
              <v-col cols="12">
                <h5>Quản trị hệ thống có quyền tiếp cận tất cả workspace</h5>
                <v-expansion-panels inset class="my-1">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Những biên tập được tiếp cận workspace này
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <v-list-item v-for="(user, id) in users" :key="id">
                          <v-list-item-content>
                            <v-card flat>
                              {{ user }}
                              <v-icon
                                color="error"
                                @click="deleteUser(id)"
                                right
                                >mdi-close</v-icon
                              >
                            </v-card>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-select
                        v-model="user"
                        :items="usersOptions"
                        label="Thêm người dùng"
                        filled
                      ></v-select>
                      <v-icon color="green" @click="addUser(user)"
                        >mdi-check</v-icon
                      >
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </base-form>
        </v-tab-item>
        <!-- tab WMS -->
        <v-tab-item v-if="useWMS">
          <base-form ref="form" lazy-validation @submit.stop="onSubmit">
            <v-row no-gutters>
              <v-col cols="12">
                <v-switch
                  v-model="wmsSettings.enabled"
                  inset
                  label="Bật WMS với không gian làm việc này"
                  class="mx-1"
                >
                </v-switch>
                <v-switch
                  v-model="wmsSettings.watermark.enabled"
                  inset
                  label="Bật chữ ký ảnh"
                  class="mx-1"
                >
                </v-switch>
                <v-file-input
                  v-model="wmFile"
                  show-size
                  counter
                  label="URL chữ ký ảnh"
                  :disabled="!wmsSettings.watermark.enabled"
                  @change="preview_image"
                  filled
                ></v-file-input>
                <v-img
                  :src="wmImageSrc"
                  max-height="100"
                  max-width="100"
                  class="my-2"
                ></v-img>
                <!-- <img :src="'../../../public/static/img/logo.png'"> -->
                <v-select
                  v-model="wmsSettings.watermark.position"
                  :items="positions"
                  label="Vị trí chữ ký ảnh"
                  :disabled="!wmsSettings.watermark.enabled"
                  item-text="name"
                  item-value="value"
                  filled
                ></v-select>
                <v-slider
                  v-model="wmsSettings.watermark.transparency"
                  :min="0"
                  :max="100"
                  :disabled="!wmsSettings.watermark.enabled"
                ></v-slider>
                <v-text-field
                  v-model="wmsSettings.watermark.transparency"
                  type="number"
                  label="Mức độ trong suốt của chữ lý ảnh"
                  :disabled="!wmsSettings.watermark.enabled"
                  filled
                  readonly
                ></v-text-field>
                <v-switch
                  v-model="wmsSettings.getFeatureInfoMimeTypeCheckingEnabled"
                  inset
                  label="Bật kiểm tra kiểu MIME cho yêu cầu GetFeatureInfo"
                  class="mx-1"
                  filled
                >
                </v-switch>
                <v-switch
                  v-model="wmsSettings.getMapMimeTypeCheckingEnabled"
                  inset
                  label="Bật kiểm tra kiểu MIME cho một yêu cầu GetMapInfo"
                  class="mx-1"
                >
                </v-switch>
                <v-text-field
                  v-model="wmsSettings.maxBuffer"
                  type="number"
                  label="Số bộ đệm bản đồ tối đa"
                  filled
                ></v-text-field>
                <v-text-field
                  v-model="wmsSettings.maxRenderingErrors"
                  type="number"
                  label="Số lỗi kết xuất tối đa"
                  filled
                ></v-text-field>
                <v-text-field
                  v-model="wmsSettings.maxRenderingTime"
                  type="number"
                  label="Thời gian kết xuất tối đa"
                  filled
                ></v-text-field>
                <v-text-field
                  v-model="wmsSettings.maxRequestMemory"
                  type="number"
                  label="Bộ nhớ yêu cầu tối đa"
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </base-form>
        </v-tab-item>
        <!-- tab WFS -->
        <v-tab-item v-if="useWFS">
          <base-form ref="form" lazy-validation @submit.stop="onSubmit">
            <v-row no-gutters>
              <v-col cols="12">
                <v-switch
                  v-model="wfsSettings.enabled"
                  inset
                  label="Bật WFS với không gian làm việc này"
                  class="mx-1"
                >
                </v-switch>
                <v-switch
                  v-model="wfsSettings.allowGlobalQueries"
                  inset
                  label="Truy vấn toàn cục"
                  class="mx-1"
                >
                </v-switch>
                <v-switch
                  v-model="wfsSettings.featureBounding"
                  inset
                  label="Trả về vùng bao của dữ liệu"
                  class="mx-1"
                >
                </v-switch>
                <v-switch
                  v-model="wfsSettings.includeWFSRequestDumpFile"
                  inset
                  label="Bao gồm tệp kết xuất yêu cầu WFS"
                  class="mx-1"
                >
                </v-switch>
                <v-text-field
                  v-model="wfsSettings.maxFeatures"
                  type="number"
                  label="Số đặc trưng tối đa"
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </base-form>
        </v-tab-item>
      </v-tabs>
    </div>
    <div v-else>
      <base-form ref="form" lazy-validation @submit.stop="onSubmit">
        <v-row no-gutters>
          <v-col cols="12">
            <field-group
              v-model="dialog.data.name"
              autofocus
              :error-messages="dialog.error.name"
              filled
              label="Tên hiển thị"
              no-label
            ></field-group>
          </v-col>
        </v-row>
      </base-form>
    </div>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_WORKSPACE } from '@api'
import { mapGetters } from 'vuex'
import axios from '@service/auth-sdk'
import JsonToFormData from '@/src/utils/JsonToFormData'
const FormData = require('form-data')
export default {
  components: {},
  props: {},
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    current_user_role: 0,
    tabs: ['Phân quyền'],
    tab: null,
    newWSName: '',
    globalWMS: {},
    globalWFS: {},
    enableSettingWMS: false,
    enableSettingWFS: false,
    users: [],
    usersOptions: [],
    user: '',
    //wms settings
    wmFile: null,
    useWMS: false,
    wmsSettings: {
      bboxForEachCRS: false,
      citeCompliant: false,
      dynamicStylingDisabled: false,
      getFeatureInfoMimeTypeCheckingEnabled: false,
      getMapMimeTypeCheckingEnabled: false,
      interpolation: '',
      maxBuffer: 0,
      maxRenderingErrors: 0,
      maxRenderingTime: 0,
      maxRequestMemory: 0,
      maxRequestedDimensionValues: 0,
      onlineResource: '',
      schemaBaseURL: '',
      watermark: {
        enabled: false,
        position: '',
        transparency: 0,
        url: {},
      },
      abstrct: '',
      accessConstraints: '',
      enabled: false,
      fees: '',
      internationalAbstract: '',
      internationalTitle: '',
      maintainer: '',
      name: '',
      title: '',
      versions: '',
    },
    positions: [
      {
        name: 'Phía trên bên trái',
        value: 'TOP_LEFT',
      },
      {
        name: 'Phía trên chính giữa',
        value: 'TOP_CENTER',
      },
      {
        name: 'Phía trên bên phải',
        value: 'TOP_RIGHT',
      },
      {
        name: 'Chính giữa bên trái',
        value: 'MID_LEFT',
      },
      {
        name: 'Trung tâm',
        value: 'MID_CENTER',
      },
      {
        name: 'Chính giữa bên phải',
        value: 'MID_RIGHT',
      },
      {
        name: 'Phía dưới bên trái',
        value: 'BOT_LEFT',
      },
      {
        name: 'Phía dưới chính giữa',
        value: 'BOT_CENTER',
      },
      {
        name: 'Phía dưới bên phải',
        value: 'BOT_RIGHT',
      },
    ],
    initialWMS: false,
    initialWFS: false,
    //wfs settings:
    useWFS: false,
    wfsSettings: {
      accessConstraints: '',
      allowGlobalQueries: false,
      canonicalSchemaLocation: false,
      citeCompliant: false,
      enabled: false,
      encodeFeatureMember: false,
      featureBounding: false,
      fees: '',
      gml: {
        entry: [
          {
            version: 'V_10',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
          {
            version: 'V_20',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
          {
            version: 'V_11',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
        ],
      },
      hitsIgnoreMaxFeatures: false,
      includeWFSRequestDumpFile: false,
      maxFeatures: 0,
      metadataLink: '',
      onlineResource: '',
      schemaBaseURL: '',
      serviceLevel: 'COMPLETE',
      simpleConversionEnabled: false,
      verbose: false,
    },
    nstyles: [
      'EPSG Code',
      'OGC HTTP URL',
      'OGC EXPERIMENTAL URN',
      'OGC URN',
      'OGC HTTP URI',
    ],
    levels: ['Cơ bản', 'Giao dịch', 'Hoàn thiện'],
    wmImageSrc: '',
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  created() {
    this.getGlobalWMS()
    this.getGlobalWFS()
  },
  methods: {
    open(item, type) {
      this.getRole()
      this.getGlobalWMS()
      this.getGlobalWFS()
      this.wmImageSrc = '/api/workspace/' + item.id + '/watermark'
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, item))
      if (!this.isCreateDialog) {
        this.initialWMS = false
        this.initialWFS = false
        this.getEnableSettings(item)
        this.getUsers()
        this.getUsersOptions()
        Object.assign(
          this.$data.wmsSettings,
          this.$options.data.call(this).wmsSettings
        )
        Object.assign(
          this.$data.wfsSettings,
          this.$options.data.call(this).wfsSettings
        )
      }
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      if (this.current_user_role == 1) {
        if (this.isCreateDialog) {
          this.dialog.data.enable_setting_wms = false
          this.dialog.data.enable_setting_wfs = false
          this.dialog.data.enable_wms = this.globalWMS.enabled
          this.dialog.data.enable_wfs = this.globalWFS.enabled
        } else {
          this.dialog.data.enable_setting_wms = this.useWMS
          this.dialog.data.enable_setting_wfs = this.useWFS
          this.dialog.data.enable_wms = this.useWMS
            ? this.wmsSettings.enabled
            : this.globalWMS.enabled
          this.dialog.data.enable_wfs = this.useWFS
            ? this.wfsSettings.enabled
            : this.globalWFS.enabled
        }
      }
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        this.newWSName = data.name
        let res = this.isCreateDialog
          ? await API_WORKSPACE.create(data)
          : await API_WORKSPACE.update(data.id, data)
        if (res && !res.error) {
          this.dialog.data = res.data
          if (this.isCreateDialog) {
            let datas = await Promise.all([])
          } else {
            let datas = await Promise.all([
              this.deleteOrCreateFiles(),
              this.setUser(),
            ])
          }
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    //get role to enable change ws
    getRole() {
      for (var i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].code == 'access:admin') {
          this.current_user_role = 1
        }
      }
    },
    //after turn on/off wms/wfs settings, change number of tabs
    getTabs() {
      if (this.useWMS && this.useWFS) {
        this.tabs = ['Phân quyền', 'WMS', 'WFS']
      } else if (this.useWMS && !this.useWFS) {
        this.tabs = ['Phân quyền', 'WMS']
      } else if (!this.useWMS && this.useWFS) {
        this.tabs = ['Phân quyền', 'WFS']
      } else {
        this.tabs = ['Phân quyền']
      }
    },
    preview_image() {
      if (this.wmFile) {
        this.wmImageSrc = URL.createObjectURL(this.wmFile)
      } else {
        this.wmImageSrc = '/api/workspace/' + this.dialog.data.id + '/watermark'
      }
    },
    getCurrentWMS(item) {
      if (this.current_user_role == 1) {
        if (this.dialog.data.id != null) {
          if (item.enable_setting_wms) {
            this.useWMS = true
            this.getTabs()
            return axios
              .get(`workspace/${this.dialog.data.id}/wms_settings`)
              .then((response) => {
                for (const setting in response.data.wms) {
                  this.$set(
                    this.wmsSettings,
                    setting,
                    response.data.wms[setting]
                  )
                }
              })
          } else {
            axios.get('workspaces/wms_settings').then((response) => {
              for (const setting in response.data.wms) {
                this.$set(this.wmsSettings, setting, response.data.wms[setting])
              }
            })
          }
        }
      }
    },
    //WFS settings
    getCurrentWFS(item) {
      if (this.current_user_role == 1) {
        if (this.dialog.data.id != null) {
          if (item.enable_setting_wfs) {
            this.useWFS = true
            this.getTabs()
            return axios
              .get(`workspace/${this.dialog.data.id}/wfs_settings`)
              .then((response) => {
                for (const setting in response.data.wfs) {
                  this.$set(
                    this.wfsSettings,
                    setting,
                    response.data.wfs[setting]
                  )
                }
              })
          } else {
            axios.get('workspaces/wfs_settings').then((response) => {
              for (const setting in response.data.wfs) {
                this.$set(this.wfsSettings, setting, response.data.wfs[setting])
              }
            })
          }
        }
      }
    },
    //delete/create wms.xml and wfs.xml
    async deleteOrCreateFiles() {
      if (this.current_user_role == 1) {
        if (this.initialWMS && !this.useWMS) {
          axios.delete(`workspace/${this.dialog.data.name}/wms_file`)
        }
        if (this.initialWFS && !this.useWFS) {
          axios.delete(`workspace/${this.dialog.data.name}/wfs_file`)
        }
        if (this.useWMS) {
          if (this.wmsSettings.enabled && this.wmsSettings.watermark.enabled) {
            let formData = new FormData()
            formData.append('position', this.wmsSettings.watermark.position)
            formData.append(
              'transparency',
              this.wmsSettings.watermark.transparency
            )
            formData.append('wmFile', this.wmFile)
            //const headers = { 'Content-Type': 'multipart/form-data' }
            axios.post(`workspace/${this.newWSName}/watermark_image`, formData)
          }
          axios.put(`workspace/${this.newWSName}/wms_file`, {
            wms: this.wmsSettings,
          })
        }
        if (this.useWFS) {
          axios.put(`workspace/${this.newWSName}/wfs_file`, {
            wfs: this.wfsSettings,
          })
        }
      }
    },
    //get global wms and wfs settings for creating new workspaces
    getGlobalWMS() {
      if (this.current_user_role == 1) {
        axios.get('workspaces/wms_settings').then((response) => {
          this.globalWMS = response.data.wms
        })
      }
    },
    getGlobalWFS() {
      if (this.current_user_role == 1) {
        axios.get('workspaces/wfs_settings').then((response) => {
          this.globalWFS = response.data.wfs
        })
      }
    },
    //if wms/wfs is enabled in settings, enable them for new workspaces
    getEnableSettings(item) {
      this.getCurrentWMS(item)
      this.initialWMS = true
      this.getCurrentWFS(item)
      this.initialWFS = true
    },
    //get users who can not access a certain workspace
    getUsersOptions() {
      axios
        .get(`user_workspace/user/${this.dialog.data.id}`, {
          params: {
            type: 'others',
          },
        })
        .then((response) => {
          this.usersOptions = []
          for (var i = 0; i < response.data.length; i++) {
            this.usersOptions.push(response.data[i].name)
          }
        })
    },
    //get and set users who can access  a certain workspace
    getUsers() {
      axios
        .get(`user_workspace/user/${this.dialog.data.id}`, {
          params: {
            type: 'owned',
          },
        })
        .then((response) => {
          this.users = []
          for (var i = 0; i < response.data.length; i++) {
            this.users.push(response.data[i].name)
          }
        })
    },
    deleteUser(id) {
      this.usersOptions.push(this.users[id])
      this.users.splice(id, 1)
    },
    addUser(user) {
      if (user != '') {
        this.users.push(user)
        this.usersOptions = this.usersOptions.filter(function(e) {
          return e !== user
        })
      }
    },
    setUser() {
      axios.post('user_workspace/user', {
        workspace_id: this.dialog.data.id,
        users: this.users,
      })
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
